export const EVENT_NAMES = {
  HOME_PAGE_LOADED: "Buzz_HomePage_Loaded",
  ARTICLE_LIST_PAGE_LOADED: "Buzz_ArticleListPage_Loaded",
  TAG_LIST_PAGE_LOADED: "Buzz_TagListPage_Loaded",
  ARTICLE_PAGE_LOADED: "Buzz_ArticlePage_Loaded",
  SECTION_CLICKED: "Buzz_Section_clicked",
  SUB_PAGE_LOADED: "Buzz_SubPage_Loaded",
  ARTICLE_CATEGORY_CLICKED: "Buzz_ArticleCategory_Clicked",
  ARTICLE_CARD_CLICKED: "Buzz_ArticleCard_Clicked",
  ALL_ARTICLES_SEE_ALL_CLICKED:
    "Buzz_AllArticlesSellAll_Clicked",
  ALL_ARTICLES_LOAD_MORE_POSTS_CLICKED:
    "Buzz_AllArticlesLoadMorePosts_Clicked",
  BEST_OF_CATEGORY_SEE_ALL_CLICKED:
    "Buzz_BestOfCategorySellAll_Clicked",
  CATEGORY_LIST_PAGINATION_CLICKED:
    "Buzz_CategoryArticleListPagination_Clicked",
  TAGGED_LIST_PAGINATION_CLICKED:
    "Buzz_TagArticleListPagination_Clicked",
  CATEGORY_PILL_CLICKED: "Buzz_CategoryPill_Clicked",
  TAG_PILL_CLICKED: "Buzz_TagPill_Clicked",
  SHARE_WIDGET_DESKTOP_CLICKED:
    "Buzz_ShareWidgetDesktop_Clicked",
  SHARE_WIDGET_MOBILE_CLICKED:
    "Buzz_ShareWidgetMobile_Clicked",
  COPY_ARTICLE_LINK_CLICKED: "Buzz_CopyArticleLink_Clicked",
  POPULAR_CATEGORY_CLICKED: "Buzz_PopularCategory_Clicked",
  POPULAR_POST_CLICKED: "Buzz_PopularPost_Clicked",
  POPULAR_POST_LOAD_MORE_CLICKED:
    "Buzz_PopularPostsLoadMore_Clicked",
};

export const EVENT_FIELDS = {
  SECTION_NAME: "sectionName",
  ITEM_NAME: "itemName",
  CATEGORY: "category",
  SELECTED_CATEGORY: "selectedCategory",
  REDIRECTION_URL: "redirectionUrl",
  CURRENT_URL: "currentUrl",
  TITLE: "title",
  SUB_TITLE: "subTitle",
  PAGE_NUMBER: "pageNumber",
  CURRENT_PAGE: "currentPage",
  TOTAL_PAGES: "totalPages",
  SOURCE: "source",
  FLOW: "flow",
};

export const EVENT_CATEGORY = {
  CALCULATORS: "Calculators",
};

export const EVENT_SECTION_NAME = {
  BREADCRUMB: "Breadcrumb",
  PAGINATION: "Pagination",
};

export const SECTION_IDS = {
  FEATURED_ARTICLE: "FEATURED_ARTICLE",
  ALL_ARTICLES: "ALL_ARTICLES",
  ARTICLE_CATEGORY_CAROUSEL: "ARTICLE_CATEGORY_CAROUSEL",
  MOST_POPULAR_ARTICLES: "MOST_POPULAR_ARTICLES",
  BEST_OF_CATEGORY_ARTICLES: "BEST_OF_CATEGORY_ARTICLES",
  RELATED_ARTICLES: "RELATED_ARTICLES",
  SHARE_WIDGET_TOP: "SHARE_WIDGET_TOP",
  SHARE_WIDGET_BOTTOM: "SHARE_WIDGET_BOTTOM",
  CATEGORY_PILL: "CATEGORY_PILL",
  RELATED_TAGS_PILL: "RELATED_TAGS_PILL",
  COPY_LINK_DESKTOP: "COPY_LINK_DESKTOP",
  COPY_LINK_MOBILE: "COPY_LINK_MOBILE",
  CATEGORY_ARTICLE_LIST: "CATEGORY_ARTICLE_LIST",
  PAGINATION: "PAGINATION",
  TAGGED_CATEGORY_LIST: "TAGGED_CATEGORY_LIST",
  RELATED_TAGS: "RELATED_TAGS",
  POPULAR_CATEGORIES: "POPULAR_CATEGORIES",
  POPULAR_POSTS: "POPULAR_POSTS",
};

export const EVENT_SOURCE = {
  HOME: "BUZZ_HOME",
  CATEGORY_ARTICLE_LIST: "BUZZ_CATEGORY_ARTICLE_LIST",
  TAG_ARTICLE_LIST: "BUZZ_TAG_ARTICLE_LIST",
  ARTICLE: "BUZZ_ARTICLE",
  CALCULATORS_HOME: "CALCULATORS_HOME",
};

export const PLATFORM = {
  DESKTOP: "DESKTOP",
  MOBILE: "MOBILE",
};
